<script>
  import TourModulePage from "../../../../modules/Curatorial/Tour/Page/TourModulePage.svelte";

  const GOOGLE_SPREAD_ID = "1lti7o-EjShre4OH4EmbL_bK6izQgvuNWnsQgoVvUblw";
  const COMMON_CONFIG_SHEET_ID = "1059031698";
</script>

<div class="tourPage_kv">
  <h3>
    <img
      class="pc"
      src="/protected/img/curatorial/202007_tour360/kv_title.svg"
      alt="" />
    <img
      class="mob"
      src="/protected/img/curatorial/202007_tour360/kv_title_mob.svg"
      alt="" />
  </h3>
  <div class="guys">
    <div class="guy guy1">
      <img src="/protected/img/curatorial/202007_tour360/guys1.svg" alt="" />
    </div>
    <div class="guy guy2">
      <img src="/protected/img/curatorial/202007_tour360/guys2.svg" alt="" />
    </div>
    <div class="guy guy3">
      <img src="/protected/img/curatorial/202007_tour360/guys3.svg" alt="" />
    </div>
    <div class="guy guy4">
      <img src="/protected/img/curatorial/202007_tour360/guys4.svg" alt="" />
    </div>
    <div class="guy guy5">
      <img src="/protected/img/curatorial/202007_tour360/guys5.svg" alt="" />
    </div>
  </div>
</div>

<TourModulePage
  google_spread_id={GOOGLE_SPREAD_ID}
  common_config_sheet_id={COMMON_CONFIG_SHEET_ID} />